import React from 'react'
import { Section } from 'newComponents'
import './styles.scss'

const SimpleQuote = (props) => {
  const { data } = props
  const { primary } = data
  const { content } = primary

  const quoteText = content?.text

  return (
    <Section className="simple-quote">
      <blockquote className="simple-quote-text">{quoteText}</blockquote>
    </Section>
  )
}

export default SimpleQuote
